import { render } from "./searchEvents.vue?vue&type=template&id=153c3ca2"
import script from "./searchEvents.vue?vue&type=script&lang=js"
export * from "./searchEvents.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_laravelProjects\\2sport\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__